import BankAccountBalance from "../model/BankAccountBalance";
import { addPresentation } from "./presentation";
import { formatDate, formatAmount } from "../lib/misc";

export default addPresentation(BankAccountBalance, {
  sort: (a, b) => a.date.getTime() - b.date.getTime(),
  canAdd: true,
  canEdit: true,
  canRemove: false,
  columns: [
    { title: "Account", width: "60%", align: "left", content: { projectors: (x) => x.account.shortName } },
    { title: "Date", width: "20%", align: "left", content: { projectors: (x) => formatDate(x.date) } },
    { title: "Balance", width: "20%", align: "right", content: { projectors: (x) => formatAmount(x.balance) } },
  ],
});
